import React, {PureComponent} from "react"
import {get} from "lodash"

import Card from "@irati/ui/src/Layout/Card"
import AccountRewardsQuery, {QueryData} from "@irati/reward/apollo/query/AccountRewards"
import Loader from "@irati/utils/services/apollo/Loading/Loader"
import scrollAtBottom from "@irati/utils/scroll/scrollAtBottom"
import authentication from "@irati/auth"

import EmptyRewards from "@irati-web/reward/src/components/MyRewards/EmptyRewards"
import MyRewardsList from "@irati-web/reward/src/components/MyRewards/MyRewardsList"
import MyRewardPopup from "@irati-web/reward/src/components/MyRewards/MyRewardsPopup/MyRewardPopup"
import LoadMore from "../../../components/LoadMore"

interface Props {
  show: boolean,
  onHide(): void,
  redemption: RewardRedemption
}

interface State {
  hasRefetchingError: boolean,
  selectedRedemption?: RewardRedemption
}

class Rewards extends PureComponent<Props, State> {
  state = {
    selectedRedemption: undefined,
    hasRefetchingError: false
  }

  onLoadMore: any = null

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll = () => {
    const atBottom = scrollAtBottom()
    const {hasRefetchingError} = this.state
    if (atBottom && !hasRefetchingError && this.onLoadMore) {
      this.fetchMore()
    }
  }

  openPopUp = (selectedRedemption: RewardRedemption) => {
    this.setState({selectedRedemption})
  }

  closePopUp = () => {
    this.setState({selectedRedemption: undefined})
  }

  fetchMore = () => {
    this.setState({
      hasRefetchingError: false
    })
    this.onLoadMore().catch(() => {
      this.setState({
        hasRefetchingError: true
      })
    })
  }

  hasReceivedData(data: QueryData) {
    return data && "rewardRedemptions" in data && "results" in data.rewardRedemptions && data.rewardRedemptions.results.length > 0
  }

  hasMoreData(data: QueryData) {
    return !!get(data, "rewardRedemptions.hasMore", false)
  }

  render() {
    const {uuid, businessId} = authentication.user()
    const variables = {
      tenantId: businessId,
      userId: uuid,
      limit: 5
    }
    const {selectedRedemption, hasRefetchingError} = this.state
    return (
      <>
        <Card tiny noBorder>
          <AccountRewardsQuery variables={variables}>
            {({data, refetch, fetchMore, loading: isLoading, error, networkStatus}) => {
              const hasData = this.hasReceivedData(data)
              const hasMore = this.hasMoreData(data)
              const isRefetching = networkStatus === 3
              const hasError = error || hasRefetchingError
              this.onLoadMore = !isLoading && hasMore ? () => fetchMore(variables) : null

              return isLoading && !isRefetching ? (
                <Loader />
              ) : (
                <>
                  {hasData && <MyRewardsList openPopUp={this.openPopUp} redemptions={data.rewardRedemptions.results} />}
                  {isLoading && <Loader />}
                  {!isLoading && hasError && <LoadMore onClick={error ? () => refetch() : this.fetchMore} />}
                  {!isLoading && !hasError && !hasData && <EmptyRewards />}
                </>
              )
            }}
          </AccountRewardsQuery>
        </Card>
        <MyRewardPopup onHide={this.closePopUp} show={!!selectedRedemption} redemption={selectedRedemption} />
      </>
    )
  }
}

export default Rewards
